const INITIAL_STATE = {};
export function user(state = INITIAL_STATE, action: any) {
    return state;
}
